'use strict';


function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
        results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
var configJSON;

var api = {
	storeConfigJSON: function (json) {
		configJSON = json;
	},
	getConfigData: function () {
		return configJSON;
	},
	get skip() {
		return getParameterByName('skip') === 'true';
	},

	get debug() {
		return getParameterByName('debug') === 'true';
	},
	getQuery: function (str) {
		return getParameterByName(str);
	}

};


module.exports = api;